'use strict';

var React = require('react');
var env = require('./env-100217af.js');

function usePrevious(value) {
    var ref = React.useRef();
    React.useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
function useWindowEventListener(eventName, handler, options, isActive) {
    if (options === void 0) { options = {}; }
    if (isActive === void 0) { isActive = true; }
    var handlerRef = React.useRef(handler);
    React.useEffect(function () {
        handlerRef.current = handler;
    }, [handler]);
    React.useEffect(function () {
        function eventListener(ev) {
            if (handlerRef.current) {
                handlerRef.current.call(this, ev);
            }
        }
        if (isActive) {
            window.addEventListener(eventName, eventListener, env.isInternetExplorer ? !!options.capture : options);
        }
        return function () {
            if (isActive) {
                window.removeEventListener(eventName, eventListener, env.isInternetExplorer ? !!options.capture : options);
            }
        };
    }, [eventName, isActive, options]);
}
var useOnClickOutside = function (handler, withEscHandler) {
    if (withEscHandler === void 0) { withEscHandler = true; }
    var ref = React.useRef(null);
    var listenerOptions = { capture: true };
    React.useEffect(function () {
        if (ref.current) {
            document.addEventListener('click', handleClickOutside, listenerOptions);
            if (withEscHandler) {
                document.addEventListener('keydown', handleOnEsc, listenerOptions);
            }
        }
        return function () {
            document.removeEventListener('click', handleClickOutside, listenerOptions);
            if (withEscHandler) {
                document.removeEventListener('keydown', handleOnEsc, listenerOptions);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleClickOutside = function (e) {
        if (ref.current && !ref.current.contains(e.target)) {
            handler(e);
        }
    };
    var handleOnEsc = function (e) {
        if (e.key === 'Escape') {
            handler(e);
        }
    };
    return ref;
};

exports.useOnClickOutside = useOnClickOutside;
exports.usePrevious = usePrevious;
exports.useWindowEventListener = useWindowEventListener;
//# sourceMappingURL=hooks-11aa6f97.js.map
